import createTable from '../CompanyDetailsTable';

import style from './style.module.css';

export default createTable({
  namePrefix: 'tradeShowTargets',
  tableName: 'Trade Groups',
  columns: [
    { field: 'name', suggest: true, className: style.name },
    { field: `year`, title: 'Year', editable: false, className: style.year },
    { field: 'event.city', title: 'City', editable: false },
    { field: 'event.state', title: 'State', editable: false },
    { field: 'event.startDate', title: 'Date', type: 'date', editable: false },
    { field: 'booth', title: 'Booth', editable: true },
  ],
});
